import { Link } from 'react-router-dom'
import SectionTitle from "../SectionTitle/SectionTitle";
import Services from "../../api/Services";

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ServiceSection = (props) => {
    const { hclass, sliceStart = 0, sliceEnd = 6, showSectionTitle = true } = props;
    
    return (
        <section className={hclass}>
            <div className="container">
                {showSectionTitle && (
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-12">
                            <div className="section_title">
                                <h3>Comprehensive Regenerative Medicine Solutions</h3>
                                <p style={{textAlign: "center"}}>
                                    Advanced treatments targeting the root cause of your condition using cutting-edge regenerative medicine protocols
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                <div className="row">
                    {Services.slice(sliceStart, sliceEnd).map((servic, sky) => (
                        <div className="col-lg-4 col-md-6 col-12" key={sky}>
                            <div className="service_card">
                                <div className="icon">
                                    <i className={servic.icon}></i>
                                </div>
                                <div className="content">
                                    <h2>{servic.title}</h2>
                                    <p>{servic.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row mt-5">
                    <div className="col-12 text-center">
                        <div className="cta-text">
                            <h4 style={{
                                fontSize: '20px',
                                color: '#666',
                                marginBottom: '25px',
                                fontWeight: '500'
                            }}>
                                Don&apos;t see your specific condition? 
                            </h4>
                            <Link 
                                onClick={ClickHandler} 
                                to="/contact" 
                                className="theme-btn"
                                style={{
                                    fontSize: '16px'
                                }}
                            >
                                Schedule Your Consultation
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;